<template>
  <div>
    <b-modal ref="model_ql" title="提示" ok-title="确定" ok-only>
      <p>申请状态异常，请联系银行</p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "BaseApplyAction",
  data() {
    return {
      bankCode: "",
      applyDetail: "",
      isInner: "",
    };
  },
  mounted: function () {
    this.applyDetail = this.$route.query.applyDetail;
    // this.bankCode = this.$route.query.bankCode;
    this.isInner = this.$route.query.isInner;
    this.decodeData(this.applyDetail);
  },
  methods: {
    toQiluBank: function (applyInfo) {
      this.$router.replace({
        name: "ApplyCard_ql", //
        params: {
          ...applyInfo,
        },
      });
    },
    decodeData: function (input) {
      let newinput = encodeURIComponent(input); //部署需用newinput，本地测试用input
      //解密数据
      // console.log("********decodeData********")
      var that = this;
      var formData = new FormData();
      console.log("isInner->" + this.isInner);
      if ("inner" === this.isInner) {
        //公众号内部跳转到本页面
        formData.append("applyDetail", input);
        formData.append("bankCode", "01B1");
      } else {
        //公众号外部跳转到本页面
        formData.append("applyDetail", newinput);
        formData.append("bankCode", "01B1");
      }
      axios({
        method: "post",
        url: config.config_ql.getDecodeData,
        data: formData,
      })
        .then(function (response) {
          // console.log(response)
          //{"checkStatus":"0","merchNo":"01B1","mobileNo":"xx","flowNo":"500000000757468"}
          if (response.status == 200) {
            let data = response.data;
            if (data.checkStatus == "2") {
              that.showQlStateMsg();
              return;
            } else if (
              data.checkStatus == "0" ||
              data.checkStatus == "1" ||
              data.checkStatus == "3"
            ) {
              let params = data; // JSON.stringify(data);
              //申请卡页面
              // console.log("data", data);
              sessionStorage.setItem("entrance", 1);
              that.toQiluBank(params); //跳转到齐鲁银行选择卡面页面
            }
          } else {
          }
          let dataRes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showQlStateMsg: function () {
      this.$refs["model_ql"].show();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/qilubank/BaseApplyAction_ql.vue